import LoadingAnimationData from '@assets/lottie/loading.json';
import { LottieAnimation } from '@components/common/LottieAnimation';
import React from 'react';

interface LoadingAnimationProps {
  message?: string;
}

export const LoadingAnimation: React.FC<LoadingAnimationProps> = ({
  message = 'Loading...',
}) => {
  return (
    <div className="flex h-full min-h-[100vh - 160px] items-center justify-center px-4">
      <div className="flex flex-col items-center gap-2">
        <LottieAnimation animationData={LoadingAnimationData} />
        <p className="text-gray-500 text-sm italic hidden">{message}</p>
      </div>
    </div>
  );
};
